<template>
  <div class="report-manage-page">
    <van-nav-bar title="体测举报记录管理" fixed placeholder />

    <van-dropdown-menu active-color="#1989fa" class="filter-menu">
      <van-dropdown-item v-model="filterProject" :options="projectOptions" />
      <van-dropdown-item v-model="filterStatus" :options="statusOptions" />
    </van-dropdown-menu>

    <div class="toolbar">
      <van-button type="warning" icon="bullhorn-o" size="small" block round plain @click="simulateAddReport">
        模拟收到学生新举报
      </van-button>
    </div>

    <div class="report-list" v-if="filteredReports.length > 0">
      <div class="report-card" v-for="item in filteredReports" :key="item.id">
        <div class="card-header">
          <div class="target-info">
            <span class="label">被举报人：</span>
            <strong class="name">{{ item.targetName }}</strong>
            <span class="class-name">({{ item.className }})</span>
          </div>
          <van-tag :type="getStatusType(item.status)" size="medium" mark>
            {{ getStatusText(item.status) }}
          </van-tag>
        </div>

        <div class="card-body">
          <div class="info-row">
            <span class="label">涉及项目：</span>
            <van-tag plain type="primary" size="medium">{{ item.project }}</van-tag>
          </div>
          <div class="info-row">
            <span class="label">举报时间：</span>
            <span class="val">{{ item.time }}</span>
          </div>
          <div class="info-row">
            <span class="label">举报事由：</span>
            <span class="val text-danger">{{ item.reason }}</span>
          </div>
          <div class="info-row" v-if="item.evidence">
            <span class="label">附加证据：</span>
            <span class="val text-grey">{{ item.evidence }}</span>
          </div>
          <div class="info-row result-row" v-if="item.result">
            <span class="label text-success">处理结果：</span>
            <span class="val text-success font-bold">{{ item.result }}</span>
          </div>
        </div>

        <div class="card-footer">
          <template v-if="item.status === 0">
            <van-button size="small" type="info" round @click="confirmReport(item.id)">
              确认属实
            </van-button>
            <van-button size="small" type="warning" plain round @click="rejectReport(item.id)">
              驳回/不属实
            </van-button>
          </template>

          <template v-if="item.status === 1">
            <van-button size="small" type="primary" round @click="processReport(item.id)">
              执行处理
            </van-button>
            <van-button size="small" type="default" plain round @click="cancelAudit(item.id)">
              解除审核
            </van-button>
          </template>

          <template v-if="item.status === 2">
            <van-button size="small" type="default" plain round @click="cancelAudit(item.id)">
              解除审核(重置)
            </van-button>
          </template>

          <van-button size="small" type="danger" plain round @click="deleteReport(item.id)" style="margin-left: 8px;">
            删除记录
          </van-button>
        </div>
      </div>
    </div>
    
    <van-empty v-else description="暂无相关项目的举报记录" />
  </div>
</template>

<script>
export default {
  name: 'ReportManagement',
  data() {
    return {
      // 筛选条件
      filterProject: 'ALL',
      filterStatus: -1,

      // 下拉菜单配置项
      projectOptions: [
        { text: '全部运动项目', value: 'ALL' },
        { text: '1000米跑', value: '1000米跑' },
        { text: '800米跑', value: '800米跑' },
        { text: '立定跳远', value: '立定跳远' },
        { text: '仰卧起坐', value: '仰卧起坐' },
      ],
      statusOptions: [
        { text: '全部状态', value: -1 },
        { text: '待核实', value: 0 },
        { text: '待处理', value: 1 },
        { text: '已处理', value: 2 },
      ],

      // 举报记录数据源 (status: 0待核实, 1待处理(已核实), 2已处理)
      reports: [
        { id: 101, targetName: '李强', className: '初三(2)班', project: '1000米跑', time: '2026-04-11 09:30', reason: '他在跑步测验中抄近道跨越草坪', evidence: '有学生拍摄了手机视频', status: 0, result: '' },
        { id: 102, targetName: '王芳', className: '初一(1)班', project: '仰卧起坐', time: '2026-04-10 14:15', reason: '别人帮她压着感应器刷次数', evidence: '', status: 1, result: '' },
        { id: 103, targetName: '陈伟', className: '初二(4)班', project: '立定跳远', time: '2026-04-09 16:00', reason: '跳远时脚尖明显越过起跳线，考官没看到', evidence: '起跳板上有明显脚印越界', status: 2, result: '成绩已作废，责令重考并扣除诚信分' },
      ],
    };
  },
  computed: {
    // 动态计算属性，根据筛选条件过滤展示的数据
    filteredReports() {
      return this.reports.filter(item => {
        const matchProject = this.filterProject === 'ALL' ? true : item.project === this.filterProject;
        const matchStatus = this.filterStatus === -1 ? true : item.status === this.filterStatus;
        return matchProject && matchStatus;
      });
    }
  },
  methods: {
    // 状态 UI 映射
    getStatusText(status) {
      const map = { 0: '待核实', 1: '待处理', 2: '已处理' };
      return map[status] || '未知';
    },
    getStatusType(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'success' };
      return map[status] || 'default';
    },

    // ========== 业务操作核心逻辑 ==========

    // 1. 模拟新增举报 (体现新增数据变动)
    simulateAddReport() {
      const projects = ['1000米跑', '800米跑', '立定跳远', '仰卧起坐'];
      const randomProject = projects[Math.floor(Math.random() * projects.length)];
      
      const newReport = {
        id: Date.now(),
        targetName: '模拟学生' + Math.floor(Math.random() * 100),
        className: '初二(3)班',
        project: randomProject,
        time: new Date().toLocaleString(),
        reason: '匿名同学举报其佩戴了非本人的运动手环',
        evidence: '教务处监控核实中',
        status: 0, // 新举报默认待核实
        result: ''
      };
      // 插入数组首位
      this.reports.unshift(newReport);
      // 为了直观看到效果，将项目筛选自动切过去
      if (this.filterProject !== 'ALL' && this.filterProject !== randomProject) {
        this.filterProject = 'ALL';
      }
      this.$toast.success('已收到新举报信息');
    },

    // 2. 确认属实 (改变状态 0 -> 1)
    confirmReport(id) {
      this.$dialog.confirm({
        title: '确认属实',
        message: '确认该举报情况属实吗？确认后将流转至待处理状态。'
      }).then(() => {
        const item = this.reports.find(r => r.id === id);
        if (item) item.status = 1;
        this.$toast.success('已确认举报属实');
      }).catch(() => {});
    },

    // 2.1 驳回举报 (处理不属实的举报)
    rejectReport(id) {
      this.$dialog.confirm({
        title: '驳回举报',
        message: '确认该举报不属实并驳回吗？'
      }).then(() => {
        const item = this.reports.find(r => r.id === id);
        if (item) {
          item.status = 2; // 标记为已处理
          item.result = '核实不属实，已驳回此举报';
        }
        this.$toast('举报已驳回');
      }).catch(() => {});
    },

    // 3. 执行处理 (改变状态 1 -> 2)
    processReport(id) {
      this.$dialog.confirm({
        title: '执行处理',
        message: '将对该违规学生成绩作废并记入档案，确认执行？'
      }).then(() => {
        const item = this.reports.find(r => r.id === id);
        if (item) {
          item.status = 2;
          item.result = '违规已惩处，当次成绩记为0分';
        }
        this.$toast.success('处理完成');
      }).catch(() => {});
    },

    // 4. 解除审核 (状态重置为 0，相当于撤销确认/处理)
    cancelAudit(id) {
      this.$dialog.confirm({
        title: '解除审核',
        message: '解除后，该举报记录将重置为【待核实】状态，确认操作？'
      }).then(() => {
        const item = this.reports.find(r => r.id === id);
        if (item) {
          item.status = 0;
          item.result = ''; // 清空处理结果
        }
        this.$toast('状态已重置');
      }).catch(() => {});
    },

    // 5. 删除记录 (移出数组)
    deleteReport(id) {
      this.$dialog.confirm({
        title: '删除警告',
        message: '确定要彻底删除该条举报记录吗？删除后不可恢复。',
        confirmButtonColor: '#ee0a24'
      }).then(() => {
        this.reports = this.reports.filter(r => r.id !== id);
        this.$toast.success('删除成功');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.report-manage-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 24px;
}

.toolbar {
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #ebedf0;
}

/* 卡片样式设计 */
.report-list {
  padding: 12px;
}
.report-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 头部 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f3f5;
  margin-bottom: 10px;
}
.target-info .label {
  font-size: 13px;
  color: #646566;
}
.target-info .name {
  font-size: 16px;
  color: #323233;
}
.target-info .class-name {
  font-size: 12px;
  color: #969799;
  margin-left: 4px;
}

/* 主体内容 */
.card-body {
  padding-bottom: 6px;
}
.info-row {
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 6px;
  display: flex;
  align-items: flex-start;
}
.info-row .label {
  color: #969799;
  width: 70px;
  flex-shrink: 0;
}
.info-row .val {
  color: #323233;
  flex: 1;
}

.result-row {
  background-color: #f0f9eb;
  padding: 8px;
  border-radius: 4px;
  margin-top: 8px;
}

/* 底部按钮区 */
.card-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px dashed #ebedf0;
  gap: 8px; /* 按钮间距 */
}

/* 辅助颜色 */
.text-danger { color: #ee0a24; }
.text-primary { color: #1989fa; }
.text-success { color: #07c160; }
.text-grey { color: #969799; }
.font-bold { font-weight: bold; }
</style>